import { render, staticRenderFns } from "./TheProjectRoyaltiesAmount.vue?vue&type=template&id=a65762a0&"
import script from "./TheProjectRoyaltiesAmount.vue?vue&type=script&lang=js&"
export * from "./TheProjectRoyaltiesAmount.vue?vue&type=script&lang=js&"
import style0 from "./TheProjectRoyaltiesAmount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports